export const breakpoints = {
  huge: 1440,
  large: 1170,
  medium: 768,
  small: 450,
  xsmall: 320,
} as const;
